import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { WhatsAppFAB } from "../../Common/Components/WhatsAppFAB";
import {
  fetchConfig,
  fetchCustomerInfo,
  logout,
} from "../../Services/MainService";
import { fetchOrders, getFailedOrder } from "../../Services/OrderService";
import { fetchDeliveryType } from "../../Services/CartService";

export const ConsumerIndex = () => {
  const dispatch = useDispatch();
  const loggedIn = useSelector((x) => x.LoggedIn);
  const config = useSelector((x) => x.Config);
  const role = useSelector((x) => x.Role);
  const [configLoading, setConfigLoading] = React.useState(true);
  const [stillLoading, setStillLoading] = React.useState(false);
  const [init, setInit] = React.useState(true);
  const navigate = useNavigate();
  React.useEffect(() => {
    fetchConfig().then(
      (res) => {
        setConfigLoading(false);
        dispatch({ type: "setConfig", payload: res });
      },
      (er) => {
        console.warn(er, "err while fetching config...");
        toast.error("Something went wrong while fetching configuration...");
      }
    );
  }, []);
  React.useEffect(() => {
    if (init) setInit(false);
    else {
      setStillLoading(true);
      fetchDeliveryTypes(() => {
        if (loggedIn && config) {
          fetchCustomerInfo().then(
            (res) => {
              if (config?.customer_verification && !res.is_phone_verified) {
                navigate("/app/phone-verification", { replace: true });
              }
              dispatch({ type: "setCustomer", payload: res });
              fetchOrders({
                limit: config?.laundry_customer_maximum_order,
                offset: 1,
              }).then(
                (res) => {
                  setStillLoading(false);
                  dispatch({ type: "setOngoingOrders", payload: res.data });
                  getFailedOrder().then(
                    (res12) => {
                      setStillLoading(false);
                      if (res12?.data?.id)
                        navigate(`/app/payment-failed?id=${res12?.data?.id}`);
                    },
                    (er) => {
                      setStillLoading(false);
                    }
                  );
                },
                (er) => {
                  if (er && er.errors && er.errors.length > 0)
                    er.errors.forEach((x) => toast.error(x.message));
                  else
                    toast.error(
                      "Something went wrong while fetching Ongoing Orders!"
                    );
                }
              );
            },
            (er) => {
              console.warn(er, "err while fetching customer...");
              if (er?.message?.toLowerCase().includes("unauthenticated")) {
                logout();
              } else
                toast.error(
                  "Something went wrong while fetching customer details..."
                );
              setStillLoading(false);
            }
          );
        } else setStillLoading(false);
      });
    }
  }, [loggedIn, config]);
  const fetchDeliveryTypes = (callback) => {
    fetchDeliveryType(50, 1)
      .then((res) => {
        dispatch({ type: "setOrderTypes", payload: [...res].reverse() });
      })
      .finally(() => {
        if (callback) callback();
      });
  };
  return (
    <>
      {configLoading || stillLoading ? (
        <div className="config-loading">
          <img
            src={process.env.PUBLIC_URL + "/assets/images/loader.gif"}
            style={{ height: "70px", width: "70px", objectFit: "contain" }}
            alt=""
          />
        </div>
      ) : (
        <>
          <Outlet />
          <WhatsAppFAB />
        </>
      )}
    </>
  );
};
